// AgentDetailsPage.jsx

import PageContainer from "../../components/common/PageContainer";
import useAgentDetailsPage from "../../hooks/useAgentDetailsPage";

import AgentHeader from "../../components/agents/AgentHeader";
import AgentConfigurations from "../../components/agents/AgentConfigurations";
import AgentPropertiesSection from "../../components/agents/AgentPropertiesSection";
import AgentSettingsModals from "../../components/agents/AgentSettingsModals";

import AgentBasicInfoSection from "../../components/agents/AgentBasicInfoSection";
import AgentVoiceProvidersSection from "../../components/agents/AgentVoiceProvidersSection";
import AgentMetaSection from "../../components/metaAds/AgentMetaSection";
import AgentMetaAdsSection from "../../components/metaAds/AgentMetaAdsSection";
import AgentWhatsAppSection from "../../components/metaAds/AgentWhatsAppSection";
import AgentTelephoneSection from "../../components/metaAds/AgentTelephoneSection";
import MetaConversationCounts from "../../components/agents/MetaConversationCounts";
import Loader from "../../components/ui/Loader/Loader";
import Accordion from "../../components/ui/Accordion";
import {
  FAKE_CONVERSATION_COUNTS,
  FAKE_CONVERSATION_LIMITS,
} from "../../dev/fakeConversationCounts";
import { usePropertiesByAgentQuery } from "../../queries/properties/usePropertiesQuery";
import { limitsFromSources } from "../../utils/conversationCounts";

import { useAuthStore } from "../../store/authStore";
import { useAgentStore } from "../../store/agentStore";
import { SHOW_VOICE_AND_META } from "../../config/features";

export default function AgentDetailsPage() {
  const state = useAgentDetailsPage();
  const { role } = useAuthStore();
  const { selectedAgent } = useAgentStore();

  const isAdmin = role === "admin";
  const agentId = state.agentDetails?.agent?.id;
  const { data: propertiesData } = usePropertiesByAgentQuery(agentId);
  const properties = Array.isArray(propertiesData)
    ? propertiesData
    : propertiesData?.data || propertiesData?.properties || [];
  const conversationLimits = limitsFromSources({
    whatsapp: state.agentDetails?.whatsapp,
    properties,
  });

  if (state.isLoading ) {
    return <Loader />;
  }

  return (
    <PageContainer >
      <section className="agent-details-page">
      <AgentHeader navigate={state.navigate} />
      <AgentBasicInfoSection />
      <AgentConfigurations
        openLeadScoreModal={state.openLeadScoreModal}
        openChatboxModal={state.openChatboxModal}
        onOpenSettings={() => state.setShowSettingsModal(true)}
        agentDetails={state.agentDetails}
      />
      {SHOW_VOICE_AND_META && isAdmin && agentId && (
        <>
          <Accordion title="Meta" className="accordion-section agent-meta-panel">
            <AgentMetaSection hideTitle>
              <AgentMetaAdsSection
                agentId={agentId}
                metaAdsGroups={
                  selectedAgent?.meta_ads ?? state.agentDetails?.meta_ads ?? []
                }
              />
              <AgentWhatsAppSection
                agentId={agentId}
                whatsapp={
                  selectedAgent?.whatsapp ?? state.agentDetails?.whatsapp
                }
              />
              <AgentTelephoneSection
                agentId={agentId}
                telephone={
                  selectedAgent?.meta?.telephone ??
                  state.agentDetails?.meta?.telephone
                }
              />
            </AgentMetaSection>
            <MetaConversationCounts
              counts={state.agentDetails?.conversation_counts}
              limits={conversationLimits}
            />
            {/* <MetaConversationCounts
              preview
              counts={FAKE_CONVERSATION_COUNTS}
              limits={FAKE_CONVERSATION_LIMITS}
            /> */}
          </Accordion>
          <AgentVoiceProvidersSection agentId={agentId} />
        </>
      )}
      <AgentPropertiesSection
        agentId={state.agentDetails?.agent?.id}
        setSelectedProperty={state.setSelectedProperty}
        />
        <AgentSettingsModals {...state} />
      </section>
    </PageContainer>
  );
}